import Layout from '../components/layout'
import Meta from '../components/meta'
import tw from 'twin.macro'
import { graphql, Link} from 'gatsby'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import '../components/fonts/flexo.css'
import { navigate } from 'gatsby'

const orderedIds = [
  "3s2h8fTeNeICELcmKIKU6x",
  "6Fi5hEUrvHQirmpt72b3ou",
  "1We4OlpawAwnjqBCeomaDz",
  "5RoDGGuHKE3IoBpmaHxFBD",
];

const Skimmi = props => {
	const {
		SkimmiHeaderBanner,
		DolphinSkimmiLogo,
		Skimmi300,
		Skimmi200,
		Skimmi300Logo,
		Skimmi200Logo,
		ComparisonTable,
		LifestyleImage,
		BottomCTA
	} = props.data

	const { SkimmiGridImages } = props.data;

	const orderedGridImages = orderedIds.map(id =>
		SkimmiGridImages.nodes.find(
			node => node.contentful_id === id
		)
	).filter(Boolean);

	return (
		<Layout>
			<Meta title="Skimmi | Robotic Cordless Pool Cleaner" keywords={[ 'skimmi', 'pool', 'equipment' ]}
				description="Dolphin Skimmi equipped with an automatic navigation algorithm and smart sensors, Dolphin Skimmi safely paddles around your pool and collects leaves, and other debris.."
			/>

			{/* Hero Section */}
			<div css={tw`relative w-full`}>

				<div css={tw`relative w-full`}>
					<Img
						{...SkimmiHeaderBanner.nodes[0]}
						loading="eager"
						css={tw`block w-full`}
						style={{ width: '100%' }}
						imgStyle={{
						width: '100%',
						height: 'auto',
						objectFit: 'cover',
						}}
					/>

					{/* ENQUIRE NOW – inside image on desktop */}
					<Link
						to="/en-ZA/dolphin/skimmi-line"
						css={[tw`hidden md:flex absolute bottom-12 left-0 right-0 mx-auto justify-center py-4 text-[#3882AC] bg-white
						rounded-full xl:text-lg uppercase hover:text-white hover:bg-blue-500 transition-colors duration-200 shadow-2xl`,
						{ fontFamily: 'Flexo, system-ui, sans-serif !important', width: '20rem', fontWeight: 800 }]}>
						DISCOVER DOLPHIN SKIMMI™
					</Link>
				</div>

				{/* DISCOVER DOLPHIN SKIMMI™ – below image on mobile */}
				<div css={tw`flex justify-center mt-8 md:hidden`}>
					<Link to="/en-ZA/dolphin/skimmi-line"
						css={[tw` w-40 text-center py-2 text-[#3882AC] bg-white rounded-full font-semibold
							uppercase hover:text-white hover:bg-blue-500 transition-colors duration-200 shadow-2xl`,
							{ fontFamily: 'Flexo, system-ui, sans-serif !important', width: '17rem', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.25)' }]}>
						DISCOVER DOLPHIN SKIMMI™
					</Link>
				</div>
			</div>

			{/* After Hero Description */}
			<div css={tw`max-w-screen-lg py-10 md:py-20 px-8 md:px-16 mx-auto w-full text-center flex flex-col gap-5 text-lg`} >
				<h1 css={[ tw`text-lg lg:text-[2rem] xl:text-[2.5rem] leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
					Cleans every corner, avoids every obstacle. <br/> No manual Skimming Ever.
				</h1>

				<h3 css={[ tw`text-base lg:text-lg xl:text-xl leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 700 }]} >
					Discover the{' '}
					<span css={{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }}>
						Dolphin Skimmi™
					</span>, the first solar-powered surface cleaner that makes
					skimming effortless. Dolphin Skimmi™ glides across your pool with agility, avoiding
					cords, hoses, and walls to reach every corner where debris collects.
					<br/><br/>
					With smart solar charging, it finds the sunniest spot to recharge - no plugs, no downtime,
					no retrieval. Patented obstacle avoidance and edge-detection ensure 99% coverage
					while cleaning faster and more efficiently than traditional skimming methods.
				</h3>
			</div>

			{/* The Skimmi Difference */}
			<div css={tw`max-w-screen-lg pb-5 md:pb-20 px-4 sm:px-6 md:px-8 mx-auto w-full text-center flex flex-nowrap items-end justify-center gap-2 md:gap-6`}>
				<h1 css={[tw`text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
					THE
				</h1>

				<img
					src={DolphinSkimmiLogo.nodes[0].fluid.src} // use the src from fluid
					alt={DolphinSkimmiLogo.nodes[0].title}
					tw="w-auto h-full max-h-12 sm:max-h-16 md:max-h-20 lg:max-h-24 xl:max-h-28"
				/>

				<h1 css={[tw`text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
					DIFFERENCE
				</h1>
			</div>

			{/* The Skimmi Difference Images */}
			<section css={tw`py-6 max-w-screen-xl mx-auto px-8`}>
				<div css={tw`grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8`}>
					{orderedGridImages.map((item, index) => (
					<div key={item.contentful_id ?? index} css={tw`flex flex-col items-center`}>
						<div css={tw`w-full relative overflow-hidden rounded-lg`}>
						<Img
							fluid={item.fluid}
							alt={item.title}
							css={tw`w-full h-full object-cover`}
						/>
						</div>
						<h2 css={[tw`my-4 text-center text-black leading-none text-[1rem] md:text-[1.3rem] lg:text-[1.4rem] xl:text-[1.7rem]`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
							{item.title}
						</h2>
						<p css={[tw`text-base md:text-lg lg:text-[1.4rem] xl:text-[1.4rem] text-center text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
							{item.description}
						</p>
					</div>
					))}
				</div>
			</section>

			{/* Meet the Dolphin Skimmi */}
			<div css={tw`max-w-screen-lg py-5 md:py-10 px-8 md:px-16 mx-auto w-full text-center flex flex-col gap-5 text-lg`} >
				<h1 css={[ tw`text-lg lg:text-[2rem] xl:text-[2.5rem] leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
					Meet the Dolphin Skimmi™
				</h1>
			</div>

			{/* Meet the Dolphin Skimmi Images */}
			<div css={[ tw`text-center px-8 pb-2 md:pb-3 lg:pb-4 mx-auto max-w-screen-lg w-full`]}>
				{/* Grid Container - 2 columns, 3 rows */}
				<div css={[tw`grid md:grid-cols-2 gap-x-8 gap-y-6 md:gap-x-10 md:gap-y-14 lg:gap-x-12 lg:gap-y-16 max-w-6xl mx-auto items-stretch`]}>
					{/* Skimmi 300 Content */}
					<div css={[ tw`bg-white rounded-lg items-start text-center md:text-left ` ]}>
						<div css={[tw`block md:hidden rounded-[24px] overflow-hidden mb-4`]}>
							<Img
								{...Skimmi300.nodes[0]}
								loading="lazy"
								css={[tw`w-full h-full object-cover rounded-[24px]`]}
							/>
						</div>
						<div tw="flex justify-center md:justify-start mb-3">
							<img
								src={Skimmi300Logo.nodes[0].fluid.src}
								alt={Skimmi300Logo.nodes[0].title}
								tw="w-auto h-full max-h-8 sm:max-h-10 md:max-h-12 lg:max-h-16 xl:max-h-20"
							/>
						</div>
						<p css={[ tw`text-base md:text-lg lg:text-xl md:italic mt-3 mb-3 text-[#3882AC]`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 } ]}>
							Best for full-featured performance
						</p>

						<ul css={[ tw`list-disc list-outside text-sm md:text-base lg:text-lg text-black text-left space-y-1.5 mx-auto md:mx-0`,
							{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 400, lineHeight: 1.1, paddingLeft: '1.25rem' } ]}>
							<li>Premium Maytronics One™ app control</li>
							<li>Advanced cleaning modes: Edge-Free, Edge Cleaning, Leaf Catch, Advanced Eco Mode</li>
							<li>Advanced Eco Mode - 3 options</li>
							<li>Call-to-Edge retrieval</li>
							<li>Hassle-free cleaning with easy-access fine filter tray</li>
							<li>Cordless - Solar or external charging</li>
							<li>3-year warranty</li>
						</ul>

						<button
							onClick={() => window.open('https://mydolphin.co.za/product/dolphin-skimmi-300/', '_blank')}
							css={[
								tw`block bg-black hover:bg-gray-800 text-white text-sm md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200 mt-8 mx-auto md:mx-0 self-start`,
								{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 },
							]}
							>
							DISCOVER DOLPHIN SKIMMI™ 300
						</button>

					</div>

					{/* Skimmi 300 Image*/}
					<div css={[tw`hidden md:block h-full flex`]}>
						<div css={[tw`rounded-[12px] md:rounded-[72px] h-full overflow-hidden`]}>
							<Img
								{...Skimmi300.nodes[0]}
								loading="lazy"
								css={[tw`h-full object-cover rounded-[12px] md:rounded-[72px]`]}
							/>
						</div>
					</div>
				</div>
				<div css={[tw`grid md:grid-cols-2 gap-x-8 gap-y-6 md:gap-x-10 md:gap-y-14 lg:gap-x-12 lg:gap-y-16 mt-0 md:mt-16 max-w-6xl mx-auto items-stretch`]}>
					{/* Skimmi 200 Image*/}
					<div css={[tw`hidden md:block h-full flex`]}>
						<div css={[tw`rounded-lg md:rounded-[72px] h-full overflow-hidden`]}>
							<Img
								{...Skimmi200.nodes[0]}
								loading="lazy"
								css={[tw`h-full object-cover rounded-lg md:rounded-[72px]`]}
							/>
						</div>
					</div>

					{/* Skimmi 200 Content */}
					<div css={[ tw`bg-white rounded-lg items-start text-center md:text-left ` ]}>
						<div css={[tw`block md:hidden rounded-[24px] overflow-hidden mb-4`]}>
							<Img
								{...Skimmi200.nodes[0]}
								loading="lazy"
								css={[tw`w-full h-full object-cover rounded-[24px]`]}
							/>
						</div>
						<div tw="flex justify-center md:justify-start mb-3">
							<img
								src={Skimmi200Logo.nodes[0].fluid.src} // use the src from fluid
								alt={Skimmi200Logo.nodes[0].title}
								tw="w-auto h-full max-h-8 sm:max-h-10 md:max-h-12 lg:max-h-16 xl:max-h-20"
							/>
						</div>
						<p css={[ tw`text-base md:text-lg lg:text-xl md:italic mt-3 mb-3 text-[#3882AC]`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 } ]}>
							Best for smart convenience
						</p>
						<ul css={[ tw`list-disc list-outside text-sm md:text-base lg:text-lg text-black text-left space-y-1.5 mx-auto md:mx-0`,
							{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 400, lineHeight: 1.1, paddingLeft: '1.25rem' } ]}>
							<li>Maytronics One™ app control</li>
							<li>Advanced cleaning modes: Edge-Free, Leaf Catch, Eco Mode</li>
							<li>Hassle-free cleaning with easy-access fine filter tray</li>
							<li>Cordless - Solar or external charging</li>
							<li>2-year warranty</li>
						</ul>
						<button
							onClick={() => window.open('https://mydolphin.co.za/product/dolphin-skimmi-200/', '_blank')}
							css={[
								tw`block bg-black hover:bg-gray-800 text-white text-sm md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200 mt-8 mx-auto md:mx-0 self-start`,
								{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 },
							]}
							>
							DISCOVER DOLPHIN SKIMMI™ 200
						</button>
					</div>
				</div>
			</div>

			{/* Right Dolphin Skimmi */}
			<div css={tw`max-w-screen-lg py-5 md:py-10 px-8 md:px-16 mx-auto w-full text-center flex flex-col gap-5 text-lg`} >
				<h1 css={[ tw`text-lg lg:text-[2rem] xl:text-[2.5rem] leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
					Which Dolphin Skimmi™ is Right for You?
				</h1>

				<h2 css={[ tw`text-lg lg:text-xl xl:text-2xl leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 500 }]} >
					Compare the Dolphin Skimmi™ Range and find{' '}
  					<span css={tw`lg:block`}>the Dolphin Skimmi™ for your pool needs</span>
				</h2>

			</div>

			{/* Comparison Table */}
			<div css={tw`max-w-screen-lg pb-10 md:pb-15 px-8 mx-auto w-full`}>
				{/* Table Image */}
				<Img
					{...ComparisonTable.nodes[0]}
					loading="lazy"
					css={[tw`w-full h-full object-cover`]}
				/>
				{/* Buttons below image */}
				<div css={tw`flex mt-4 w-full`}>
					<div css={{ width: '17%' }}></div>

					<div css={{ width: '38.5%', display: 'flex', justifyContent: 'center' }}>
						<button
						css={[tw`bg-[#57C8DF] text-sm md:text-base lg:text-lg text-white font-semibold px-6 py-2 rounded-full shadow-inner hover:bg-blue-300 transition`,
							{ fontFamily: 'Flexo, system-ui, sans-serif !important' }]}
							onClick={() => window.open('https://mydolphin.co.za/product/dolphin-skimmi-200/', '_blank')}
						>
						Discover Now
						</button>
					</div>

					<div css={{ width: '5%' }}></div>

					<div css={{ width: '38.5%', display: 'flex', justifyContent: 'center' }}>
						<button
							css={[tw`bg-[#57C8DF] text-sm md:text-base lg:text-lg text-white font-semibold px-6 py-2 rounded-full shadow-inner hover:bg-blue-300 transition`,
							{ fontFamily: 'Flexo, system-ui, sans-serif !important' }]}
							onClick={() => window.open('https://mydolphin.co.za/product/dolphin-skimmi-300/', '_blank')}
						>
						Discover Now
						</button>
					</div>
				</div>
			</div>

			{/* Lifestyle Image */}
			<div css={tw`max-w-screen-lg px-8 mx-auto w-full text-center flex flex-col gap-5 text-lg`} >
				<Img
					{...LifestyleImage.nodes[0]}
					loading="lazy"
					css={[tw`w-full h-full object-cover rounded-[24px]`]}
				/>
			</div>

			{/* After Hero Description */}
			<div css={tw`max-w-screen-lg px-8 py-3 md:py-5 mx-auto w-full text-center flex flex-col text-lg`} >
				<h3 css={[ tw`text-base lg:text-lg xl:text-xl leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 700 }]} >
					No matter which Dolphin Skimmi™ you choose, your pool will stay effortlessly clean, from
					corners to edges, every day. With solar-powered freedom, smart navigation, and app control,
					Dolphin Skimmi™ takes the chore out of pool care - giving you more time to relax and enjoy
					your pool. Choose your Dolphin Skimmi™, sit back, and let your Dolphin robot do the work
				</h3>
			</div>

			{/* Bottom CTA */}
			<div css={tw`max-w-screen-lg px-8 pt-5 md:pt-10 mx-auto w-full text-center flex flex-col text-lg`} >
				<Img
					{...BottomCTA.nodes[0]}
					loading="lazy"
					css={[
						tw`w-full h-auto mx-auto`,
						tw`max-w-xs md:max-w-md lg:max-w-lg xl:max-w-xl`,
					]}
				/>
			</div>

			{/* Bottom CTA Buttons */}
			<div css={tw`max-w-screen-lg px-8 pt-5 md:pt-10 pb-10 md:pb-20 mx-auto w-full text-center flex flex-col gap-5 text-lg`}>
				<div css={tw`flex justify-center gap-4 flex-wrap`}>
					<button
						onClick={() => navigate('/en-ZA/dolphin/skimmi-line')}
						css={[
							tw`bg-black hover:bg-gray-800 text-white text-xs md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200`,
							{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 },
						]}
					>
					DISCOVER NOW
					</button>

					<button
						onClick={() => navigate('/en-ZA/support/find-a-dealer/')}
						css={[
							tw`bg-black hover:bg-gray-800 text-white text-xs md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200`,
							{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 },
						]}
					>
					FIND A DEALER
					</button>
				</div>
			</div>

		</Layout>
	)
}


/**
 * Page content query
 * @private
 * @static
 * @returns {() => void}
 */
export const SkimmiPageZAQuery = graphql`
	query SkimmiPageZAQuery {
		SkimmiHeaderBanner: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4UKu5d8lGxInUJJYB7WXN6" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		DolphinSkimmiLogo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5tLXrSS4RPkKzqf0FYM1FH" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SkimmiGridImages: allContentfulAsset(
			filter: { contentful_id: { in: ["5RoDGGuHKE3IoBpmaHxFBD", "1We4OlpawAwnjqBCeomaDz", "6Fi5hEUrvHQirmpt72b3ou", "3s2h8fTeNeICELcmKIKU6x"] } }
			) {
			nodes {
				contentful_id
				title
				description
				fluid(maxWidth: 600, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		Skimmi300: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4tJ3dIPyFCSCT65W1X5tlx" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		Skimmi200: allContentfulAsset(
			filter: {
				contentful_id: { eq: "16kPb8ZItGES9Ioq0ZdgKR" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		Skimmi300Logo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3eLZO0rSCqnvWhwc7cNaeB" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		Skimmi200Logo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2KsTj9TEN6T2OEGtlOqSVi" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		ComparisonTable: allContentfulAsset(
			filter: {
				contentful_id: { eq: "426mauEc0XK9diF2VCDfYg" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		BottomCTA: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6nGy0AXygoF1EEOdYUpHli" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 600, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}

		LifestyleImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "1yj257P9McrXElQmMyXJ0R" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1920, quality: 80) {
				...GatsbyContentfulFluid_withWebp
				}
			}
		}
	}
`

Skimmi.propTypes = {
	props: PropTypes.shape({
		data: PropTypes.shape({
			SkimmiHeaderBanner: PropTypes.object,
			DolphinSkimmiLogo: PropTypes.object,
			Skimmi300Logo: PropTypes.object,
			Skimmi200Logo: PropTypes.object,
			SkimmiGridImages: PropTypes.object,
			Skimmi300: PropTypes.object,
			Skimmi200: PropTypes.object,
			ComparisonTable: PropTypes.object,
			LifestyleImage: PropTypes.object,
			BottomCTA: PropTypes.object
		}),
	}),
}
export default Skimmi
